module.exports = __webpack_public_path__ + "1c61e0aa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onboarding.mp4
// module id = 1140
// module chunks = 0 1 2 3 4 5 6 7 8